<div class="manage-profile">
  <div class="edit_profile">
    <slotcom-h2 [text]="'home.profile.editProfile' | translate"></slotcom-h2>
    <slotcom-navigation-button
      type="close"
      width="3"
      height="3"
      topPosition="-1"
      rightPosition="-1"
      (click)="close()">
    </slotcom-navigation-button>
  </div>
  <hr class="c-divider" />
  <div class="row justify-content-center avatar-container">
    <div class="avatar-box position-relative">
      @if (!imageUploaded()) {
        <slotcom-avatar
          [userId]="user.id"
          class="lg"></slotcom-avatar>
      }
      <div class="row justify-content-center avatar-icon">
        <avatar-upload (uploadStateChanged)="uploadStateChanged($event)"></avatar-upload>
      </div>
    </div>
  </div>

  <form
    [formGroup]="profileForm"
    (ngSubmit)="onSubmit()">
    <div class="c-field c-field--select c-field--filled">
      <span class="c-field__label">{{ 'home.profile.gender' | translate }}</span>
      <slotcom-dropdown
        class="c-field__input"
        formControlName="gender"
        name="gender"
        [defaultLabel]="defaultGenderOption"
        [options]="genders">
      </slotcom-dropdown>
      <div class="c-field__line"></div>
    </div>

    <div class="d-flex flex-wrap mb-3 mt-4">
      <span class="w-100 label">{{ 'home.profile.country' | translate }}</span>
      <span class="w-100">{{ user.country }}</span>
    </div>

    @if (hasEmail()) {
      <div class="suscribe">
        <label
          class="c-checkbox"
          [class.c-checkbox--checked]="profileForm.get('allowsNewsletter').value">
          <input
            type="checkbox"
            formControlName="allowsNewsletter"
            name="allowsNewsletter" />
          <span class="c-checkbox__box"></span>
          <span class="c-checkbox__label">{{ 'home.profile.allowsNewsletter' | translate }}</span>
        </label>
      </div>
    }

    <slotcom-button
      (safeClick)="onSubmit()"
      audioType="functionality"
      class="c-button--pink small">
      {{ 'common.saveChanges' | translate }}
    </slotcom-button>

    <br />

    @if (hasPassword()) {
      <div>
        <hr class="c-divider" />
        <a
          class="menu_item"
          (click)="managePassword()">
          <slotcom-h2 [text]="'home.profile.changePassword' | translate"></slotcom-h2>
        </a>
      </div>
    }

    <div>
      <hr class="c-divider" />
      <a
        class="menu_item"
        (click)="deleteAccount()">
        <slotcom-h2 [text]="'home.profile.deleteAccount' | translate"></slotcom-h2>
      </a>
    </div>
  </form>
</div>
